export default __webpack_public_path__ + "static/media/Maple-RegularItalic.f4ba5845.ttf";